import React from 'react';
import type ForgeAdminPageType from '@atlassian/jira-spa-apps-forge-admin/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyForgeAdminPage = lazyForPaint<typeof ForgeAdminPageType>(
	() =>
		import(
			/* webpackChunkName: "async-forge-spa-admin", jiraSpaEntry: "async-forge-spa-admin" */ '@atlassian/jira-spa-apps-forge-admin'
		),
);

export const ForgeAdminPage = () => (
	<LazyPage Page={LazyForgeAdminPage} pageId="forge-spa-admin" shouldShowSpinner />
);

export default ForgeAdminPage;
